export default __webpack_public_path__ + "static/media/nusEnablersLogo.08f11d5d.png";